import { render, staticRenderFns } from "./messageDeclineChat.vue?vue&type=template&id=2a16431e&scoped=true&"
import script from "./messageDeclineChat.vue?vue&type=script&lang=js&"
export * from "./messageDeclineChat.vue?vue&type=script&lang=js&"
import style0 from "./messageDeclineChat.vue?vue&type=style&index=0&id=2a16431e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16431e",
  null
  
)

export default component.exports